<script setup lang="ts">
import MapAreaLayer from "@/areas/MapAreaLayer.vue";
import MapMarkerHouseIcon from "@/areas/MapMarkerHouseIcon.vue";
import { coordinatesToMapBounds } from "@/areas/mapUtils";
import type { Area } from "@/areas/types";
import { MapContainerAsync as MapContainer } from "@/components/map/MapContainerAsync";
import { MapMarkerAsync as MapMarker } from "@/components/map/MapMarkerAsync";
import MapMarkerIcon from "@/components/map/MapMarkerIcon.vue";
import type { House } from "@/houses/types";
import type { MapMouseEvent } from "maplibre-gl";
import { computed } from "vue";

const {
  area,
  houses,
  meetingCoordinates = null,
} = defineProps<{
  area: Area;
  houses: Array<House>;
  meetingCoordinates?: [number, number] | null;
}>();

const emit = defineEmits<{
  "update:meetingCoordinates": [coordinates: [number, number] | null];
}>();

const positionOptions = computed(() => {
  return {
    bounds: coordinatesToMapBounds(area.coordinates),
  };
});
const onMapClick = (e: MapMouseEvent) => {
  const coordinates: [number, number] = [e.lngLat.lng, e.lngLat.lat];
  emit("update:meetingCoordinates", coordinates);
};
</script>

<template>
  <MapContainer
    v-slot="{ mapInstance }"
    :options="positionOptions"
    @click="onMapClick"
  >
    <MapAreaLayer :area="area" :map-instance="mapInstance" />
    <MapMarker
      v-for="house in houses"
      :key="house.id"
      :lnglat="house.coordinates"
      :map-instance="mapInstance"
    >
      <MapMarkerHouseIcon :hidden="house.hidden" />
    </MapMarker>
    <MapMarker
      v-if="meetingCoordinates"
      :lnglat="meetingCoordinates"
      :map-instance="mapInstance"
    >
      <MapMarkerIcon class="map-marker-meetingpoint" />
    </MapMarker>
  </MapContainer>
</template>
